import React from 'react';

interface AdminJsonEditorProps {
    jsonData: string;
    spoilerExpanded: boolean;
    jsonError: string;
    loading: boolean;
    onSpoilerToggle: () => void;
    onJsonChange: (json: string, error: string) => void;
}

const AdminJsonEditor: React.FC<AdminJsonEditorProps> = ({
    jsonData,
    spoilerExpanded,
    jsonError,
    loading,
    onSpoilerToggle,
    onJsonChange
}) => {
    const handleJsonChange = (value: string) => {
        let error = '';
        try {
            JSON.parse(value);
        } catch {
            error = 'Неверный формат JSON';
        }
        onJsonChange(value, error);
    };

    return (
        <div className="spoiler-container">
            <button
                type="button"
                className="spoiler-header"
                onClick={onSpoilerToggle}
                disabled={loading}
            >
                <div className="spoiler-title">
                    <span className="warning-icon">⚠️</span>
                    Расширенное редактирование JSON (только для администраторов)
                    <svg
                        className={`spoiler-icon ${spoilerExpanded ? 'rotated' : ''}`}
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                    >
                        <polyline points="6,9 12,15 18,9"/>
                    </svg>
                </div>
            </button>
            <div className={`spoiler-content ${spoilerExpanded ? 'expanded' : ''}`}>
                <div className="spoiler-warning">
                    <span className="warning-icon">⚠️</span>
                    <strong>Внимание:</strong> Это расширенное редактирование позволяет напрямую изменять JSON данные поставщика.
                    Неправильные изменения могут привести к неработоспособности интеграций. Используйте с осторожностью!
                </div>
                <div>
                    <label className="form-label-custom">
                        <span className="label-icon">📄</span>
                        JSON данные поставщика
                    </label>
                    <textarea
                        className="form-input-custom"
                        value={jsonData}
                        onChange={(e) => handleJsonChange(e.target.value)}
                        placeholder="Введите JSON данные..."
                        rows={10}
                        disabled={loading}
                        style={{
                            fontFamily: 'monospace',
                            fontSize: '0.875rem',
                            lineHeight: '1.4'
                        }}
                    />
                    {jsonError && <div className="form-error">{jsonError}</div>}
                    <div className="form-help-text">
                        Изменения в этом поле будут сохранены напрямую в базу данных.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminJsonEditor;
